/*
 * @Author       : dengjianjun
 * @Date         : 2021-11-20 15:41:23
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2022-01-04 16:15:40
 * @Description  : 公共mutation
 * @FilePath     : /es-template/src/store/modules/common/mutation.js
 */
/**
 * @description: 
 * @param {*}
 * @return {*}
 */
import { setStorage } from '@/utils/storage'
import { TRANSFER_TAB_TOGGLE } from '@/utils/train-storage'
export default {
  /**
   * @description: 设置接口请求状态
   */

  setApiStatus(state, payload) {
    state.apiStatus = { ...state.apiStatus, ...payload };
  },

  /**
   * @description: 设置公用参数
   */

  setParams(state, payload) {
    state.params = { ...state.params, ...payload };
    setStorage({
      key: 'params',
      data: { ...state.params }
    });
  },

  /**
   * @description: 设置安全区域
   */

  setSafeArea(state, payload) {
    state.safeAreaTop = payload;
  },

  /**
   * @description: 设置九章参数
   */

  setXpsmInfo(state, payload) {
    state.xpsmInfo = payload;
  },
  /**
   * @description: 设置定位信息
   */

  setLocationInfo(state, payload) {
    state.locationInfo = payload;
  },

  setHomeApolloData(state, payload) {
    setStorage({ key: TRANSFER_TAB_TOGGLE, data: payload?.union_show_status ?? 0 })
    state.homeApolloData = payload;
  },

  setHomePageData(state, payload) {
    state.homePageData = payload;
    // 设置是否命合并灰度实验
    state.userGroup = payload.user_group === 2 ? 1 : 0;
  },
  setRequestForHomeHide(state, payload) {
    state.requestForHomeHide = payload;
  },
  setRequestForMakeOrderBack(state, payload) {
    state.requestForMakeOrderBack = payload;
  },
  setBaichuanTrainPrivacy(state, payload) {
    state.baichuanTrainPrivacy = payload;
  },
  setGuideTraceId(state, payload) {
    state.guideTraceId = payload;
  },
  setBizFrom(state, payload) {
    state.bizFrom = payload;
  },
  setResetSelectSeatForRecommendBack(state, payload) {
    state.resetSelectSeatForRecommendBack = payload;
  },
  updateUniquePopupMap(state,payload) {
    state.uniquePopupMap = {
      ...state.uniquePopupMap,
      ...payload
    }
  }
};
